// extracted by mini-css-extract-plugin
module.exports = {"ProjectCont":"Project_ProjectCont__3k2nn","ModalCont":"Project_ModalCont__29d5r","ModalText":"Project_ModalText__2Ogmk"};